class TrieNode {
    constructor(value) {
        this.value = value;
        this.leaf = false;
        this.data = [];
        this.children = {};
    }
}

class DictionaryNode {
    constructor(value) {
        this.keyword = value;
        this.data = [];
        this.lev = Infinity;
    }
}

class Trie {

    root = null;
    dictionary = {};

    constructor() {
        this.root = new TrieNode('');
        this.dictionary = {};
    }

    insert(word, data) {
        if (!word) {
            return;
        }
        // in root
        let n = this.root;
        for (let i = 0; i < word.length; i++) {
            const c = word[i];
            if (!n.children.hasOwnProperty(c)) {
                n.children[c] = new TrieNode(c);
            }
            n = n.children[c];
            if (i === word.length - 1) {
                n.leaf = true;

                n.data.push(data);
            }
        }
        // in dictionar
        if(!this.dictionary.hasOwnProperty(word)){
            this.dictionary[word] = new DictionaryNode();
        }
        this.dictionary[word].keyword = word;
        this.dictionary[word].lev = Infinity;
        this.dictionary[word].data.push(data);
    }

    find(fragment) {
        if (!fragment) {
            return false;
        }
        let n = this.root;
        for (let i = 0; i < fragment.length; i++) {
            const c = fragment[i];
            if (!n.children.hasOwnProperty(c)) {
                break;
            }
            n = n.children[c];
            if (i === fragment.length - 1 && n.leaf) {
                return {
                    word: fragment,
                    data: n.data,
                };
            }
        }
        return false;
    }

    findByLev(fragment, maxLev = 2) {
        //
        if (!fragment) {
            return false;
        }

        //
        const tail = function (a) {
            let len_a = a.toString().length;
            return a.toString().slice(1, len_a);
        }
        const firstChar = function (a) {
            return a.toString().charAt(0).toLowerCase();
        }
        function levenshtein(s, t) {
            if (s === t) {
                return 0;
            }
            var n = s.length, m = t.length;
            if (n === 0 || m === 0) {
                return n + m;
            }
            var x = 0, y, a, b, c, d, g, h;
            var p = new Uint16Array(n);
            var u = new Uint32Array(n);
            for (y = 0; y < n;) {
                u[y] = s.charCodeAt(y);
                p[y] = ++y;
            }

            for (; (x + 3) < m; x += 4) {
                var e1 = t.charCodeAt(x);
                var e2 = t.charCodeAt(x + 1);
                var e3 = t.charCodeAt(x + 2);
                var e4 = t.charCodeAt(x + 3);
                c = x;
                b = x + 1;
                d = x + 2;
                g = x + 3;
                h = x + 4;
                for (y = 0; y < n; y++) {
                    a = p[y];
                    if (a < c || b < c) {
                        c = (a > b ? b + 1 : a + 1);
                    }
                    else {
                        if (e1 !== u[y]) {
                            c++;
                        }
                    }

                    if (c < b || d < b) {
                        b = (c > d ? d + 1 : c + 1);
                    }
                    else {
                        if (e2 !== u[y]) {
                            b++;
                        }
                    }

                    if (b < d || g < d) {
                        d = (b > g ? g + 1 : b + 1);
                    }
                    else {
                        if (e3 !== u[y]) {
                            d++;
                        }
                    }

                    if (d < g || h < g) {
                        g = (d > h ? h + 1 : d + 1);
                    }
                    else {
                        if (e4 !== u[y]) {
                            g++;
                        }
                    }
                    p[y] = h = g;
                    g = d;
                    d = b;
                    b = c;
                    c = a;
                }
            }

            for (; x < m;) {
                var e = t.charCodeAt(x);
                c = x;
                d = ++x;
                for (y = 0; y < n; y++) {
                    a = p[y];
                    if (a < c || d < c) {
                        d = (a > d ? d + 1 : a + 1);
                    }
                    else {
                        if (e !== u[y]) {
                            d = c + 1;
                        }
                        else {
                            d = c;
                        }
                    }
                    p[y] = d;
                    c = a;
                }
                h = d;
            }

            return h;
        }

        //
        let d = [];
        let keywords = Object.keys(this.dictionary);

        for(let keyword of keywords){
            if( keyword.length >= fragment.length - maxLev && keyword.length <= fragment.length + maxLev){
                this.dictionary[keyword].lev = levenshtein(fragment, keyword);
                d.push(this.dictionary[keyword]);
            }
        }

        return d.filter((w) => {
            return parseInt(w.lev) <= parseInt(maxLev);
        }).sort( function(a,b){ return a.lev > b.lev ? 1 : -1 });

    }

    autocomplete(fragment) {
        if (!fragment) {
            return;
        }
        let result = [];
        let n = this.root;
        for (let i = 0; i < fragment.length; i++) {
            const c = fragment[i];
            if (!n.children.hasOwnProperty(c)) {
                break;
            }
            n = n.children[c];
            if (i === fragment.length - 1) {
                const queue = [];
                queue.push([n, fragment]);
                while (queue.length) {
                    const element = queue.shift();
                    const node = element[0];
                    const word = element[1];


                    if (node.leaf) {
                        result.push({word, data: node.data})
                    }
                    for (const j in node.children) {
                        const child = node.children[j];
                        queue.push([child, word + child.value]);
                    }
                }
            }
        }
        return result;
    }

}

//

let _VueSearchTrie = {};
_VueSearchTrie.install = function (Vue, options) {
    const trie = new Trie();
    const fctInsert = function (word, data) {
        let dictionary = [...word];
        if (!Array.isArray(word)) {
            dictionary = [word];
        }
        dictionary.forEach((w) => {
            trie.insert(w, data);
        })
    };
    const fctFind = function (fragment) {
        return trie.find(fragment);
    };
    const fctFindByLev = function (fragment, maxLev) {
        return trie.findByLev(fragment, maxLev);
    };
    const fctAutocomplete = function (fragment) {
        return trie.autocomplete(fragment);
    };


    Vue.prototype.$search = {
        insert: fctInsert,
        find: fctFind,
        autocomplete: fctAutocomplete,
        findByLev: fctFindByLev,
    }

}

export const VueSearchTrie = _VueSearchTrie;
